import axios from "axios";
import cookie from "js-cookie";
import { has } from "lodash";

interface ApiProviderInterface {
  (baseUrl?: string): ProviderInterface;
  provider: ProviderInterface;
}

interface ProviderInterface {
  client: any;
  clientBlob: any;
  clientUpload: any;
  clientSSE: any;
  apiURL: string;
  token: string;
  setInterceptors: any;
}

const ApiProvider = function (baseUrl) {
  const token = cookie.get("dropla_auth");

  if (
    ApiProvider.provider &&
    ApiProvider.provider.apiURL === baseUrl &&
    ApiProvider.provider.token === token
  ) {
    return ApiProvider.provider;
  }

  const client = axios.create({
    baseURL: baseUrl,
    headers: {
      "Content-Type": "application/json"
    }
  });

  const clientBlob = axios.create({
    baseURL: baseUrl,
    headers: {
      "Content-Type": "application/json"
    },
    responseType: "blob"
  });

  const clientSSE = axios.create({
    baseURL: baseUrl,
    headers: {
      Accept: "text/event-stream"
    },
    responseType: "stream",
    adapter: "fetch"
  });

  const clientUpload = axios.create({
    baseURL: baseUrl,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

  const setInterceptors = (token) => {
    client.interceptors.request.use((config) => {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    clientBlob.interceptors.request.use((config) => {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    clientSSE.interceptors.request.use((config) => {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    clientUpload.interceptors.request.use((config) => {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    clientUpload.interceptors.response.use((config) => {
      config.data = has(config.data, "data") ? config.data.data : config.data;
      return config;
    });
  };

  if (token) {
    setInterceptors(token);
  }
  // else {
  //   client.interceptors.response.use((config) => {
  //     config.data = has(config.data, "data") ? config.data.data : config.data;
  //     return config;
  //   });
  // }

  ApiProvider.provider = {
    client,
    clientBlob,
    clientUpload,
    clientSSE,
    apiURL: baseUrl,
    token,
    setInterceptors
  };

  return ApiProvider.provider;
} as ApiProviderInterface;

export default ApiProvider;
